import { render, staticRenderFns } from "./SetCropsButton.vue?vue&type=template&id=16b3e595&scoped=true"
import script from "./SetCropsButton.vue?vue&type=script&lang=ts"
export * from "./SetCropsButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b3e595",
  null
  
)

export default component.exports